<template>
  <label for="video" class="g--label mt-4  mb-1">
    Paste your Zoom or Google Meet link here if you have one (optional)
  </label>

  <input class="g--input" v-model="teacherProvidedZoomLink" type="url" @focusout="handleVideoChange"/>

  <p class="text-xs mt-2">Zoom format:
    https://zoom.us/j/95132586590?pwd=TzhkS2ZjAURBeUtETlNXcVFzMjZUUT09</p>
  <p class="text-xs mt-1">Google Meet format: https://meet.google.com/rpo-dpax-nyo</p>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const props = defineProps({
  classItem: {
    type: Object,
    required: true,
  },
});

const teacherProvidedZoomLink = ref(props.classItem.teacherProvidedZoomLink);

const emit = defineEmits(['update:video']);
const handleVideoChange = () => {
  if (teacherProvidedZoomLink.value && !teacherProvidedZoomLink.value.startsWith('https://')) {
    teacherProvidedZoomLink.value = 'https://' + teacherProvidedZoomLink.value;
  }
  console.log('teacherProvidedZoomLink', teacherProvidedZoomLink.value);
  if (teacherProvidedZoomLink.value) {
    emit('update:video', teacherProvidedZoomLink.value);
  }

};
</script>